import { Grid, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { styles } from './Styles'
import { useSelector } from "react-redux";
const MaintenanceFase = ({ moduleName }) => {
    const maintenanceMessage = useSelector(state => state.maintenance?.data?.message);
    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            style={styles.mainContainer}
        >
            <Paper style={styles.paperStyle}>
                <Box>
                    <Typography variant="h4" sx={styles.title}  >
                        {moduleName}
                    </Typography>
                    <Box sx={styles.miniContainer} >
                        <Box
                            component="img"
                            src="https://cdn-icons-png.flaticon.com/512/5957/5957374.png"
                            alt="maintenance"
                            sx={{
                                width: 100,
                                height: 100,
                                animation: "spin 6s linear infinite",
                                "@keyframes spin": {
                                    "0%": { transform: "rotate(0deg)" },
                                    "100%": { transform: "rotate(360deg)" },
                                },
                            }}
                        />
                    </Box>

                    <Typography variant="h5" sx={styles.maintenanceMessageStyle}>
                        🚧 {maintenanceMessage ? maintenanceMessage : ''} 🚧
                    </Typography>

                </Box>
            </Paper>
        </Grid>
    );
};

export default MaintenanceFase;
